import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PointExchangeAPI from "../../../../../apiConfig/PointExchangeAPI";
import { Status } from "../../../../../redux/constant";

const initialState = {
  partnerList: {},
  status: Status.INITIAL,
  errorMessage: null,
};

export const fetchAsyncPartnerList = createAsyncThunk(
  "partnerList/fetchAsyncPartnerList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PointExchangeAPI.get("/partners");
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

const PartnerListSlice = createSlice({
  name: "partnerList",
  initialState,
  reducers: {
    resetPartnerList: state => {
      state.partnerList = {};
      state.status = Status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAsyncPartnerList.pending, state => {
        state.errorMessage = null;
        state.status = Status.LOADING;
      })
      .addCase(fetchAsyncPartnerList.fulfilled, (state, { payload }) => {
        state.partnerList = payload;
        state.status = Status.LOADED;
      })
      .addCase(fetchAsyncPartnerList.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = Status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = Status.ERROR;
      });
  },
});

export const { resetPartnerList } = PartnerListSlice.actions;

export default PartnerListSlice.reducer;
